import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { pricingPlans } from '../data/mock';

const PricingSection = ({ onGetStarted }) => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Choose Your Protection Plan
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select the package that best fits your trademark protection needs
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingPlans.map((plan) => (
            <Card
              key={plan.id}
              className={`relative p-6 rounded-xl border-2 hover:shadow-xl transition-all duration-300 flex flex-col ${
                plan.recommended
                  ? 'border-teal-500 shadow-lg scale-105'
                  : 'border-gray-200 hover:border-teal-300'
              }`}
            >
              {plan.recommended && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-teal-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Recommended
                  </span>
                </div>
              )}
              
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-slate-900 mb-2">{plan.name}</h3>
                <div className="mb-1">
                  <span className="text-3xl font-bold text-teal-600">{plan.price}</span>
                </div>
                <p className="text-sm text-gray-600">{plan.federal}</p>
              </div>

              <div className="space-y-3 mb-6 max-h-64 overflow-y-auto">
                {plan.features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <Check className="h-5 w-5 text-teal-600 flex-shrink-0 mt-0.5" />
                    <span className="text-sm text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>

              <div className="text-xs text-gray-500 mb-4 text-center italic">
                {plan.note}
              </div>

              <Button
                onClick={onGetStarted}
                className={`w-full py-3 mt-auto ${
                  plan.recommended
                    ? 'bg-teal-600 hover:bg-teal-700 text-white'
                    : 'bg-white hover:bg-teal-50 text-teal-600 border-2 border-teal-600'
                }`}
              >
                Choose {plan.name} Plan →
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;